import { render, staticRenderFns } from "./NewPress.vue?vue&type=template&id=d294d4d8&"
import script from "./NewPress.vue?vue&type=script&lang=js&"
export * from "./NewPress.vue?vue&type=script&lang=js&"
import style0 from "./NewPress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports